module.exports = __webpack_public_path__ + "static/img/invete8.3c800ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/invete8.png
// module id = EByU
// module chunks = 88